/**
 * OWL2 Entity Types
 *
 * Defines the six OWL2 entity types (Class, Datatype, ObjectProperty,
 * DataProperty, AnnotationProperty, NamedIndividual) and Individual types.
 */
// =============================================================================
// Entity Factory Functions
// =============================================================================
/**
 * Create a Class entity.
 */
export function classEntity(iri) {
    return { entityType: 'Class', iri };
}
/**
 * Create a Datatype entity.
 */
export function datatypeEntity(iri) {
    return { entityType: 'Datatype', iri };
}
/**
 * Create an ObjectProperty entity.
 */
export function objectPropertyEntity(iri) {
    return { entityType: 'ObjectProperty', iri };
}
/**
 * Create a DataProperty entity.
 */
export function dataPropertyEntity(iri) {
    return { entityType: 'DataProperty', iri };
}
/**
 * Create an AnnotationProperty entity.
 */
export function annotationPropertyEntity(iri) {
    return { entityType: 'AnnotationProperty', iri };
}
/**
 * Create a NamedIndividual entity.
 */
export function namedIndividualEntity(iri) {
    return { entityType: 'NamedIndividual', iri };
}
// =============================================================================
// Individual Factory Functions
// =============================================================================
/**
 * Create a named individual.
 */
export function namedIndividual(iri) {
    return { type: 'NamedIndividual', iri };
}
/**
 * Create an anonymous individual.
 */
export function anonymousIndividual(nodeId) {
    return { type: 'AnonymousIndividual', nodeId };
}
// =============================================================================
// Entity Type Guards
// =============================================================================
/**
 * Check if an entity is a Class.
 */
export function isClassEntity(entity) {
    return entity.entityType === 'Class';
}
/**
 * Check if an entity is a Datatype.
 */
export function isDatatypeEntity(entity) {
    return entity.entityType === 'Datatype';
}
/**
 * Check if an entity is an ObjectProperty.
 */
export function isObjectPropertyEntity(entity) {
    return entity.entityType === 'ObjectProperty';
}
/**
 * Check if an entity is a DataProperty.
 */
export function isDataPropertyEntity(entity) {
    return entity.entityType === 'DataProperty';
}
/**
 * Check if an entity is an AnnotationProperty.
 */
export function isAnnotationPropertyEntity(entity) {
    return entity.entityType === 'AnnotationProperty';
}
/**
 * Check if an entity is a NamedIndividual.
 */
export function isNamedIndividualEntity(entity) {
    return entity.entityType === 'NamedIndividual';
}
// =============================================================================
// Individual Type Guards
// =============================================================================
/**
 * Check if an individual is a named individual.
 */
export function isNamedIndividual(individual) {
    return individual.type === 'NamedIndividual';
}
/**
 * Check if an individual is an anonymous individual.
 */
export function isAnonymousIndividual(individual) {
    return individual.type === 'AnonymousIndividual';
}
